import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import Main from './components/Main';
import PageTitle from './components/PageTitle';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleError = this.handleError.bind(this);
  }

  componentDidCatch(error) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      hasError: true,
    });

    // Sending the exact exception not the stack trace
    if (window.appInsights) window.appInsights.trackException({ error });
  }

  handleError() {
    this.setState({ hasError: false });
    window.location = '/';
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <>
          <PageTitle>Something went wrong.</PageTitle>

          <Main>
            <p>{/* Any meaningful message here?? */}</p>
            <DefaultButton onClick={this.handleError} primary text="Home" />
          </Main>
        </>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
